<template>
  <div class="mall-box">
    <div class="back-box" @click="$router.push({ path: '/mall' })">
      <img
        src="@/assets/img/images/icon/back-border.png"
        alt="back-border.png"
      />
      <p>{{ $t("mall.detail.title") }}</p>
    </div>
    <div class="info-box">
      <div class="info-left-box">
        <div class="left-img-box">
          <div class="img-box">
            <img :src="detailData.image" alt="mall-item.png" />
            <div class="title">
              <p class="p1">{{ detailData.title }}</p>
              <!-- <p class="p2" v-if="detailData.status === 1">{{$t("mall.status1")}}</p>
              <p class="p2" v-else-if="detailData.status === 2">{{$t("mall.status2")}}</p>
              <p class="p2" v-else-if="detailData.status === 3">{{$t("mall.status3")}}</p>
              <p class="p2" v-else-if="detailData.status === 4">{{$t("mall.status4")}}</p> -->
            </div>
          </div>
          <div class="btn-box">
            <div
              class="btn1"
              v-if="
                detailData.cateCode === 'DIMD' || detailData.cateCode === 'GCT'
              "
              @click="$refs.toMallWebRef.dialogVisible = true"
            >
              {{ $t("mall.mallUrl") }}
            </div>
            <div class="btn2" @click="seePdf(detailData.cateCode)">
              {{ $t("mall.detail.showWhitePage") }}
            </div>
          </div>
        </div>
        <div class="info-bottom-box">
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.totalValue") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.totalValue }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.firstValue") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.firstValue }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.minBuyAmount") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.minBuyAomout }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.maxBuyAmount") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.maxBuyAomout }}</p>
            </div>
          </div>
          <div class="border" />
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.goodsType") }}</p>
              <p class="p2">
                {{detailData.summary.type}}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.mallExchange") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.isMallExchange }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.debutStartTime") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.debutStartTime }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.debutEndTime") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.debutEndTime }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="info-right-box">
        <p class="title">{{ $t("mall.detail.chainInfo") }}</p>
        <div class="info-title-box">
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.goodsName") }}</p>
            <p class="p2">{{ detailData.cateName }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.symbol") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.symbol }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.network") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.network }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.protocol") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.protocol }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.publishAmount") }}</p>
            <p class="p2">{{ detailData.summary.valueInfo.totalValue}}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.contract") }}</p>
            <div class="p3">
              {{
                isShow
                  ? detailData.summary.chainInfo.contract
                  : truncateString(detailData.summary.chainInfo.contract)
              }}
              <div class="btn" v-if="!isShow" @click="isShow = true">
                {{ $t("mall.detail.view") }}
              </div>
              <div class="btn" v-if="isShow" @click="isShow = false">
                {{ $t("mall.detail.hide") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <div class="tab">
        <div class="sel">{{ $t("mall.detail.tab1") }}</div>
      </div>
      <div class="detail-box">
        <div class="rich-content" v-html="detailData.content">{{
          detailData.infotext
        }}</div>
      </div>
    </div>

    <VFooter />
    <ToMallWeb ref="toMallWebRef" @confirm="toMallWebConfirm" />
    <QuestionPopup />
  </div>
</template>

<script>
import ToMallWeb from "./components//ToMallWeb";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    ToMallWeb,
    QuestionPopup,
  },
  data() {
    return {
      currId: "",
      isShow: false,
      detailData: {},
    };
  },
  created() {
    this.detailData = JSON.parse(
      sessionStorage.getItem("MallDataInfo") || "{}",
    );
    console.log(this.detailData);
    //     this.currId = this.$route.query.id;
    //     fetch("/JSON/detail" + this.currId + ".json")
    //       .then((response) => {
    //         if (!response.ok) {
    //           throw new Error("网络响应错误");
    //         }
    //         return response.json();
    //       })
    //       .then((data) => {
    //         this.detailData = data;
    //         if (data.id === 2) {
    //           this.detailData.infotext = `|
    // RWA.LTD为RWA Group打造的全球首家非⾦融现实世界资产代币交易平台。
    // RWA Group（前身为NFT China，现为香港国际新经济研究院全资⼦公司）由深耕区块链底层技术、代币机制上层商业应用、传统⾦融市场和商品交易领域的专业团队创立，为香港WEB3.0⾏业领先的区块链赋能产业咨询和基础设施⼀体化服务提供商。采取立⾜ 于香港、以经济上升及发达区域为重点并辐射全球的市场选取策略，RWA Group 的业务⽹络已深度覆盖中国香港，⼤陆以及东南亚等地区，并涉⾜美国市场。自2023年，RWA Group已实现连续盈利，并成功主导并助⼒多个非⾦融NFT的发⾏，客户包括比亚迪（BYDDY）等。
    // 早在上线全球唯⼀专注于非⾦融RWA代币的交易平台前，RWA Group已通过NFT的形 式多次在全球⾏业内率先尝试将多种非⾦融性资产代币化发⾏和交易，这些⽅案陆续 被香港顶级学府认可—2024年CEO付饶先⽣受邀于香港⼤学商学院ICBC项目为中国⼯商银⾏30名⾼级管理⼈员教学本公司商业案例；2025年公司的商业案例被纳⼊香港城市⼤学商学院的正式课程 IS4720 FinTech Capstone Project。同时，RWA Group获得 2024年中国WEB3.0创新创业⼤赛⼆等奖，2025EPIC百强，并积极主导制定⾏业技术规 范与评估标准，推动⽣态规范化进程。
    // 作为RWA项目概念提出、⽅案设计并且实际落地的第⼀个⾏业开拓者，RWA Group以 独创的 「⽅案定制 - 合规护航 - 技术落地 - ⽣态拓展」闭环服务体系创立为核⼼竞争⼒ ， 同时RWA.LTD将发挥 「非⾦融资产全球化」 的桥梁作用，持续推动现实世界资产 数字化的全球协同与标准化进程，引领实体资产数字化⾰命新浪潮。

    // |
    // RWA Group为实体经济企业和项目提供资产数字化的一站式解决方案。
    // 2亿创世RWA资产分配如下：
    // IEO，5%；
    // 合规与市场，10%， 初始全部锁定，根据需求适量解锁；
    // 技术与团队，5% ，1年后开始解锁，分5年按季度解锁；
    // 平台生态，80%，初始全部锁定，根据平台生态活动方案做释放；

    // RWA.ltd平台提供利润回购，每年20%的利润用于创世RWA资产回购。

    // |
    // 创世RWA资产作为平台权益可支持以下权益的兑换
    // 1、优先购凭证；
    // 2、手续费返还卡；
    // 3、RWA项目咨询服务；
    // 4、RWA项目上币；
    // 5、RWA代币商城上架服务。
    // 服务兑换上线时间以公告为准。

    // |
    // RWA的发展离不开社区的贡献，我们充分认可并付诸实施。
    // 欢迎大家加入官方社区！`;
    //         }
    //       })
    //       .catch((error) => {
    //         this.$message({
    //           type: "warning",
    //           message: this.$t("tipsVal.copyerror"),
    //         });
    //       });
  },
  methods: {
    truncateString(str) {
      if (!str) return "";
      if (str.length <= 10) return str; // 如果字符串本身就不长，直接返回

      const start = str.slice(0, 6);
      const end = str.slice(-4);
      return `${start}...${end}`;
    },
    getImageUrl(imagePath) {
      if (imagePath) return require(`@/assets/img/images/${imagePath}`);
    },
    toMallWebConfirm() {
      this.$refs.toMallWebRef.dialogVisible = true
      window.open(this.detailData.summary.serviceInfo.mallUrl);
    },
    seePdf(val) {
		window.open('PDF/'+ val +'.pdf');
    },
  },
};
</script>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: #f5f6f7;
  .back-box {
    gap: 28px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 120px 260px 60px 260px;
    img {
      width: 44px;
      height: 44px;
    }
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
  }
  .info-box {
    gap: 32px;
    display: flex;
    padding: 0 260px;
    .info-left-box {
      padding: 20px;
      flex: 1;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .left-img-box {
        display: flex;
        padding-bottom: 20px;
        justify-content: space-between;
        border-bottom: 1px solid #e2e3e3;
        .img-box {
          gap: 20px;
          display: flex;
          img {
            width: 120px;
            height: 120px;
          }
          .title {
            gap: 20px;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 24px;
              color: #333333;
            }
            .p2 {
              width: 72px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              background: #eaebed;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .btn-box {
          gap: 12px;
          display: flex;
          align-items: center;
          .btn1 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #4063ff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #4063ff;
          }
          .btn2 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            background: #4063ff;
            border-radius: 8px 8px 8px 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
          }
        }
      }
      .info-bottom-box {
        display: flex;
        margin-top: 20px;
        .border {
          margin: 0 20px;
          border-right: 1px solid #e2e3e3;
        }
        .info-title-box {
          flex: 1;
          gap: 12px;
          display: flex;
          flex-direction: column;
          .info-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #999999;
            }
            .p2 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 16px;
              color: #333333;
            }
          }
        }
      }
    }
    .info-right-box {
      padding: 20px;
      width: 568px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e2e3e3;
      }
      .info-title-box {
        flex: 1;
        gap: 12px;
        display: flex;
        flex-direction: column;
        .info-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .p1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
          }
          .p2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 16px;
            color: #333333;
          }
          .p3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 16px;
            color: #333333;
            display: flex;
            gap: 4px;
          }
          .btn {
            width: 44px;
            line-height: 28px;
            text-align: center;
            height: 28px;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }
  }
  .tab-box {
    overflow: hidden;
    background: #ffffff;
    margin: 28px 260px 120px 260px;
    border-radius: 12px 12px 12px 12px;
    .tab {
      display: flex;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .sel {
        font-weight: 800;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 2px solid #4063ff;
      }
    }
    .detail-box {
      padding: 20px;
      .rich-content {
        /deep/ img {
          width: 100%;
        }
      }
      img {
        object-fit: cover;
        width: 100%;
      }
      .file-box {
        height: 52px;
        padding: 0 20px;
        background: #f4f5f6;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          gap: 32px;
          display: flex;
          img {
            width: 28px;
            height: 32px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
          }
        }
        .btn-box {
          gap: 20px;
          display: flex;
          .btn1 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
          .btn2 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #4b6dfe;
          }
        }
      }
    }
  }
}
</style>
